import React, { useEffect, useState } from "react";
import { api } from "../../../api/apiClient";
import { ServiceInstanceAttendee } from "../../types/types";
import { notify } from "../../components-ui/toast";
import "../../../css/tables.css";

interface Props {
  serviceInstanceId: number | null;
}

export default function ServiceInstanceAttendeesTab({
  serviceInstanceId,
}: Props) {
  const [attendees, setAttendees] = useState<ServiceInstanceAttendee[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!serviceInstanceId) {
      setAttendees([]);
      return;
    }

    setLoading(true);

    api<ServiceInstanceAttendee[]>(
      `/api/serviceinstances/${serviceInstanceId}/registrations`,
    )
      .then(setAttendees)
      .catch(() => notify.error("Failed to load attendees"))
      .finally(() => setLoading(false));
  }, [serviceInstanceId]);

  if (!serviceInstanceId) {
    return (
      <div className="notification notification--info">
        Select a session to view attendees.
      </div>
    );
  }

  return (
    <div className="table table--four-col table--striped">
      {/* Header */}
      <div className="table-header">
        <div>Name</div>
        <div>Type</div>
        <div>Group / Class</div>
        <div className="table-right">Registered</div>
      </div>

      {/* Loading */}
      {loading && <div className="table-empty">Loading attendees...</div>}

      {/* Empty */}
      {!loading && attendees.length === 0 && (
        <div className="table-empty">No attendees registered yet.</div>
      )}

      {/* Rows */}
      {!loading &&
        attendees.map((a) => (
          <div key={a.partyId} className="table-row">
            <div data-label="Name" className="table-cell table-bold">
              {a.displayName}
            </div>

            <div data-label="Type" className="table-cell table-muted">
              {a.partyType}
            </div>

            <div data-label="Group / Class" className="table-cell table-muted">
              {a.serviceGroupName ?? "-"}
            </div>

            <div
              data-label="Registered"
              className="table-cell table-right table-muted"
            >
              {new Date(a.registeredDateTime).toLocaleString()}
            </div>
          </div>
        ))}
    </div>
  );
}
